module.exports = __webpack_public_path__ + "img/Settings.3188570f.svg";